// One address however it's written (DESIGN.md, "A card reads in sections": each address once): no "www.", no slash at
// its end, no "#…", http as https, the host in lower case. A card shows one pill for an address kept in two of its
// fields (its site and its links, its booking page and its links), and the web's Edit and Remove change that address
// everywhere it's kept (features/links.md, "Add, edit and remove every link on the web": one pill is one link). Plain,
// so the web view and the server read it alike.
export function sameAddress(url: string): string {
  try {
    const u = new URL(url);
    if (!/^https?:$/.test(u.protocol)) return url;
    return `https://${u.hostname.toLowerCase().replace(/^www\./, "")}${u.pathname.replace(/\/+$/, "")}${u.search}`;
  } catch {
    return url;
  }
}
